var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArchive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8688 10.6467L27.6866 6.46447C26.7489 5.52679 25.4772 5 24.1511 5H11.6666C8.9052 5 6.66663 7.23858 6.66663 10V30C6.66663 32.7614 8.9052 35 11.6666 35H28.3333C31.0947 35 33.3333 32.7614 33.3333 30V14.1822C33.3333 12.8561 32.8065 11.5843 31.8688 10.6467V10.6467Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.3333V17.5C20 16.1193 21.1193 15 22.5 15V15C23.8807 15 25 16.1193 25 17.5V23.3333C25 26.0948 22.7614 28.3333 20 28.3333V28.3333C17.2386 28.3333 15 26.0948 15 23.3333V18.3333",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArchive);
export default ForwardRef;